"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcUniqueKeyForViewField = void 0;
function calcUniqueKeyForViewField(field) {
    if (!field)
        return undefined;
    return `${field.key}.${field.propertyName || 'N'}.${field.questionNodeId || 'N'}`;
}
exports.calcUniqueKeyForViewField = calcUniqueKeyForViewField;
exports.default = calcUniqueKeyForViewField;
